// extracted by mini-css-extract-plugin
export default {"modal":"REITsFilterForm_modal__GbF-A","slide-down":"REITsFilterForm_slide-down__k6JoK"};